import {
  getEnumValue,
  parseOptionalNumericEnumFromApi,
} from '@/utils/core/data-transformation/enumHelpers';
import { CoreEnums } from '@/utils/domain/constants';

import {
  resolveRechargeIdempotencyKey,
  unwrapFormSelectValue,
} from '@/pages/configurations/ai-billing/credits/rechargeIdempotencyHelpers';

const CHECKOUT_PROVIDER = 'stripe';
const PAYMENT_SESSION_STORAGE_KEY = 'aiBillingCheckoutPaymentSessionId';

export const buildCheckoutReturnUrls = () => {
  const origin = window.location.origin;
  return {
    successUrl: `${origin}/billing/checkout/success`,
    cancelUrl: `${origin}/billing/checkout/cancel`,
  };
};

export const buildCheckoutPayload = (formData, existingKey) => {
  const resolved = parseOptionalNumericEnumFromApi(
    CoreEnums.Currency,
    unwrapFormSelectValue(formData?.currency),
  );
  const currency = resolved !== undefined ? getEnumValue(CoreEnums.Currency, resolved) : null;

  return {
    amount: Number(formData.amount),
    currency,
    provider: CHECKOUT_PROVIDER,
    idempotencyKey: resolveRechargeIdempotencyKey(existingKey),
    ...buildCheckoutReturnUrls(),
  };
};

export const persistCheckoutPaymentSessionId = (paymentSessionId) => {
  if (!paymentSessionId) return;

  try {
    sessionStorage.setItem(PAYMENT_SESSION_STORAGE_KEY, String(paymentSessionId));
  } catch {
    /* ignore quota / private mode */
  }
};

export const clearStoredCheckoutPaymentSessionId = () => {
  try {
    sessionStorage.removeItem(PAYMENT_SESSION_STORAGE_KEY);
  } catch {
    /* ignore */
  }
};

export const getStoredCheckoutPaymentSessionId = () => {
  try {
    return sessionStorage.getItem(PAYMENT_SESSION_STORAGE_KEY);
  } catch {
    return null;
  }
};

export const resolveCheckoutPaymentSessionId = (search) => {
  const params = new URLSearchParams(search || window.location.search);
  const fromUrl = params.get('paymentSessionId');
  if (fromUrl) return fromUrl;
  return getStoredCheckoutPaymentSessionId();
};
